import React from "react";
import { ReactComponent as LightLogo } from "../../../../assets/svg/light-mode.svg";
import { ReactComponent as DarkLogo } from "../../../../assets/svg/dark-mode.svg";
import { Tooltip } from "primereact/tooltip";
import { THEME } from "app/utils/types";
import { SwitchToggle } from "app/uicomponents/microcomponents/SwitchToggle";

interface ThemeSelectorProps {
  themeState: string;
  handleThemeClick: (selectedTheme: string) => void;
  isExpanded?: boolean;
  tooltipPosition?: "top" | "bottom" | "left" | "right";
  textClass?: string;
}

const ThemeSelector = ({
  themeState,
  handleThemeClick,
  isExpanded,
  tooltipPosition = "bottom",
  textClass,
}: ThemeSelectorProps) => {
  const isSummary = window.location.href.includes("summary") || isExpanded;
  const isDark = themeState === THEME.DARK;

  return (
    <>
      <SwitchToggle
        options={[
          {
            value: THEME.LIGHT,
            label: (
              <>
                <LightLogo
                  style={{
                    width: "16px",
                    height: "16px",
                    color: isDark ? "white" : "black",
                  }}
                />
                {isSummary && "Light"}
              </>
            ),
          },
          {
            value: THEME.DARK,
            label: (
              <>
                <DarkLogo
                  style={{
                    width: "16px",
                    height: "16px",
                    color: isDark ? "white" : "black",
                  }}
                />
                {isSummary && "Dark"}
              </>
            ),
          },
        ]}
        defaultValue={themeState}
        onChange={(value: string) => handleThemeClick(value as "IAPP" | "Advisor")}
        height="h-7"
        activeColor={isDark ? "bg-bluegray-700" : "bg-black-alpha-10"}
        bgColor={isDark ? "bg-blue-1100" : "bg-white"}
        className={`ip-mode-tooltip ${textClass}`}
      />

      <Tooltip
        target=".ip-mode-tooltip"
        content="Mode"
        position={tooltipPosition}
        className="tooltip-wrapper text-sm"
      />
    </>
  );
};

export default ThemeSelector;
